import { useMutation } from 'react-query'

import { postOrganizationInvitation, PostOrganizationInvitationPayload } from '@modules-deprecated/app/organization'

import { APIError } from '../../../../../../../../../utils'

interface UseInviteUserProps {
  onError?: (error?: APIError) => void
  onSuccess?: () => void
}

export interface InviteUserProps {
  organizationId: string
  payload: PostOrganizationInvitationPayload
}

export const useInviteUser = (props?: UseInviteUserProps) => {
  const { onError, onSuccess } = props || {}

  const { mutate: inviteUser, isLoading } = useMutation(
    ({ organizationId, payload }: InviteUserProps) => postOrganizationInvitation(organizationId, payload),
    {
      onError,
      onSuccess,
    },
  )

  return { isLoading, inviteUser }
}
